import { cn } from "@/lib/utils";

/** The title block that sits on the swoosh, above the card. */
export const AuthPageHeading = ({
  eyebrow,
  title,
  lead,
  align = "center",
}: {
  eyebrow?: string;
  title: string;
  lead?: string;
  align?: "center" | "left";
}) => (
  <div className={cn("mb-[26px]", align === "center" && "text-center")}>
    {eyebrow && (
      <p className="mb-2.5 font-mono text-[11.5px] font-medium uppercase tracking-[0.12em] text-muted-foreground">
        {eyebrow}
      </p>
    )}
    <h1 className="text-balance font-martina text-[32px] font-medium leading-[1.12] tracking-[-0.02em] text-foreground md:text-[38px]">
      {title}
    </h1>
    {lead && (
      <p
        className={cn(
          "mt-2 text-pretty text-[15px] leading-[1.55] text-muted-foreground",
          align === "left" && "max-w-[560px]",
        )}
      >
        {lead}
      </p>
    )}
  </div>
);
